<template>
  <div id="ravenwareSite" ref="ravenwareSite">

    <div id="site-header">
      <div class="row">
        <div class="col-md-3" id="site-logo-wrap">
          <a href="/"><img src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo" id="site-logo"></a>
          <p id="associated">Part of <a href="https://ukitnetworks.com/" target="_blank"><img src="resources/images/logos/uk_it_networks_x100.png" alt="UK IT Networks" id="associated-logo"></a></p>
        </div>
        <div class="col-md-9 menu-items">
          <div class="items">
            <a href="/home">Business Broadband</a>
            <a href="/ethernet">Leased Line</a>
            <a href="/about-us">About Us</a>
            <a href="/support">Help and Support</a>
            <a href="/partners">Partners</a>
          </div>
          <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
        </div>
      </div>
    </div>

    <div id="background-outer" style="background-image:url('resources/images/ukit_networks_business_broadband.png');">
      <div id="background-inner">

        <div id="site-hero">
          <h1>Partners</h1>
          <h2 style="margin-bottom:32px;">We work with <span>industry-leading</span> network partners<br>to provide competitive and modern telephony<br>solutions to clients within the UK and internationally</h2>
          <a href="/support" class="btn btn-ukit-primary">Contact Us</a>
        </div>

        <div class="bg-white">
          <div class="partners">
              <div class="partner" id="partner-vodafone">
                  <img src="resources/images/logos/vodafone-partner.png" alt="Vodafone">
                  <p><i>Vodafone</i> delivers intelligent communications at the speed businesses demand. Predominantly across their mobile offering.</p>
              </div>
              <div class="partner" id="partner-virgin-media">
                  <img src="resources/images/logos/virgin-media-partner.png" alt="Virgin Media">
                  <p><i>Virgin Media Business</i> is the largest B2B Virgin brand and part of the Virgin Media group. Partnered to deliver Ethernet across the UK.</p>
              </div>
              <div class="partner" id="partner-talktalk-business">
                  <img src="resources/images/logos/talktalk-business-partner.png" alt="TalkTalk Business">
                  <p><i>TalkTalk Business</i> brings affordable and resilient communications to small to medium businesses utilising their growing network footprint across the UK</p>
              </div>
              <div class="partner" id="partner-digital-wholesale-solutions">
                  <img src="resources/images/logos/digital-wholesale-solutions-partner.png" alt="Digital Wholesale Solutions">
                  <p><i>Digital Wholesale Solutions</i> is the #1 independent communications, IT and cloud services provider to the Channel</p>
              </div>
              <div class="partner" id="partner-entanet">
                  <img src="resources/images/logos/entanet-partner.png" alt="Entanet">
                  <p><i>Entanet</i> is part of the UK’s third national digital infrastructure platform and delivers fast, reliable, high quality connectivity to their channel partners throughout the UK</p>
              </div>
              <div class="partner" id="partner-gamma">
                  <img src="resources/images/logos/gamma-partner.png" alt="Gamma">
                  <p><i>Gamma</i> is a leading provider of Unified Communications as a Service (UCaaS) in the UK, supplying communication solutions via our extensive network of trusted channel partners and also directly.</p>
              </div>
              <div class="partner" id="partner-sse">
                  <img src="resources/images/logos/sse-partner.png" alt="SSE">
                  <p><i>SSE</i> know that home is the most important place in the world and are dedicated to making sure every home works brilliantly.</p>
              </div>
              <div class="partner" id="partner-openreach">
                  <img src="resources/images/logos/openreach-partner.png" alt="Openreach">
                  <p><i>Openreach</i> run the UK's digital network. They're the people who connect homes, mobile phone masts, schools, shops, banks, hospitals, libraries, broadcasters, governments and businesses – large and small – to the world.</p>
              </div>
          </div>
        </div>

        <div class="benefits-wrap">
          <div class="row">
            <div class="col-2">
              <img src="resources\images\icons\adapt\approachable_circle_x100.png">
              <h6>Approachable</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\dedicated_circle_x100.png">
              <h6>Dedicated</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\accountable_circle_x100.png">
              <h6>Accountable</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\professional_circle_x100.png">
              <h6>Professional</h6>
            </div>
            <div class="col-2">
              <img src="resources\images\icons\adapt\trustworthy_circle_x100.png">
              <h6>Trustworthy</h6>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div id="footer-top">
      <h6>Need some assistance? We can help.</h6>
      <v-btn href="/about-us">Find out more</v-btn>
    </div>

    <div id="footer-bottom">
      <div class="row">
        <div class="col-md-3">
          <img class="footer-logo" src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo">
        </div>
        <div class="col-md-9">
          <ul class="footer-menu">
            <li><a href="https://ukitnetworks.com/privacy-policy/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2479">Privacy Policy v1.0</a></li>
            <li><a href="/support" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-2542 current_page_item menu-item-2699">Customer Support</a></li>
            <li><a href="https://ukitnetworks.com/terms-and-conditions/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2478">Terms and Conditions</a></li>
          </ul>
          <div class="legal-details">
            <p>Registered in England and Wales: 8026657</p>
            <p>Ofcom Reseller ID: FLV</p>
            <p>ICO Reg Number: A422750</p>
            <p>VAT Reg Number: 121 9534 29</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/uk-it-networks-limited">
              <i class="fa fa-linkedin-square"></i>
            </a>
            <a href="https://twitter.com/ukitnetworks?lang=en">
              <i class="fa fa-twitter-square"></i>
            </a>
            <a href="https://www.facebook.com/UKITNET/">
              <i class="fa fa-facebook-square"></i>
            </a>
          </div>
          <div class="contact-icons">
            <a href="tel:03443262154">
              <i class="fa fa-phone-square"></i>
            </a>
            <a href="mailto:info@ukbusinessbroadband.com" target="_blank">
              <i class="fa fa-envelope-square"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css'
import _ from 'lodash'

export default {
  name: 'Partners',
  components: {},

  mounted() {
    this.mounted = true
    this.$nextTick(function() {
      this.iframeHeightChangeNotifyParent()
    })
    setTimeout(
      function() {
        this.iframeHeightChangeNotifyParent()
      }, 6000)
  },

  created() {
    window.addEventListener('resize', this.windowResized)
  },

  methods: {
    toggleLoading() {
      if (this.isLoading === true) {
        this.isLoading = false
      } else {
        this.isLoading = true
      }
    },

    windowResized: _.debounce(function(e) {
      let width = document.getElementById('ravenwareSite').scrollWidth
      if (width !== this.windowSize.width) {
        this.windowSize.width = document.getElementById('ravenwareSite').scrollWidth
        this.iframeHeightChangeNotifyParent()
      }
    }, 1),

    iframeHeightChangeNotifyParent: _.debounce(function(e) {
      let height
      let el = document.getElementById('ravenwareSite')
      if (el != null) {
        height = document.getElementById('ravenwareSite').scrollHeight
      } else {
        height = 200
      }
      window.parent.postMessage({ frameHeight: height }, '*')
    }, 1),

    iframeHeightSpecificSizeNotifyParent(height) {
      window.parent.postMessage({ frameHeight: height }, '*')
    },
  },

  data: () => ({
    windowSize: { width: 0 },
    isLoading: false,
    mounted: false,
    quoteFilter: { includeSOGEA: true, includeADSL: true, includeFTTC: true },
    quotes: null,
  }),
}
</script>
